import { createFileRoute } from '@tanstack/react-router';

import { buildGuards, hasFlagEnabled } from '@mint-lib/routing-guards';
import {
  fetchCompanyInfoMint2QueryOptions,
  fetchCompanyInfoQueryOptions,
  fetchPivotCurrenciesMint2QueryOptions,
  fetchPivotCurrenciesQueryOptions,
  fetchPivotDimensionsMint2QueryOptions,
  fetchPivotDimensionsQueryOptions,
  fetchPivotMetricsMint2QueryOptions,
  fetchPivotMetricsQueryOptions,
  fetchUserCurrencyQueryOptions,
} from '@mint-sdk/api-dashboards/compat';

const reportingMint2Guard = buildGuards(hasFlagEnabled('reportingMint2'));

export const Route = createFileRoute('/_secured/reporting')({
  loader: async ({ context }) => {
    const i18n = await context.getInstance('i18n', '@mint/routing');
    const title = i18n.t('Reporting | MINT');

    const [flagsmith, queryClient, profile] = await Promise.all([
      context.getInstance('flagsmith', '@mint/arm'),
      context.serviceLocator.getOrThrowInstance('queryClient'),
      context.serviceLocator.getOrThrowInstance('profile'),
      // Preload translations for all the necessary namespaces to ensure they're ready when the component renders
      context.getInstance('i18n', '@myn/dashboards-builder'),
      context.getInstance('i18n', '@mint-lib/insights-shared'),
      context.getInstance('i18n', '@mint-lib/pivot-table'),
      context.getInstance('i18n', '@mint-lib/manage-permission'),
      context.getInstance('i18n', '@myn/pivot'),
    ]);
    const guardContext = await context.getGuardContext(flagsmith);
    const isReportingMint2 = reportingMint2Guard(guardContext);

    const companyId = profile
      .getProfileData()
      ?.profile?.company?.id?.toString();

    if (companyId) {
      if (isReportingMint2) {
        Promise.allSettled([
          queryClient.prefetchQuery(
            fetchPivotDimensionsMint2QueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(
            fetchPivotMetricsMint2QueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(
            fetchCompanyInfoMint2QueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(
            fetchPivotCurrenciesMint2QueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(fetchUserCurrencyQueryOptions({})),
          // TODO: Add prefetch queries: Dashboards and DashboardsListSettings
        ]);
      } else {
        Promise.allSettled([
          queryClient.prefetchQuery(
            fetchPivotDimensionsQueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(
            fetchPivotMetricsQueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(
            fetchCompanyInfoQueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(
            fetchPivotCurrenciesQueryOptions({
              urlParams: { companyId },
            }),
          ),
          queryClient.prefetchQuery(fetchUserCurrencyQueryOptions({})),
        ]);
      }
    }

    return { title };
  },
  head: ({ loaderData }) => {
    const title = loaderData?.title;
    return {
      meta: [
        {
          title,
        },
      ],
    };
  },
});
